import { useEffect, useState } from "react";
import mapboxgl from "mapbox-gl";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN ?? "";

export const useInitializeMap = (mapContainer: any) => {
  const [map, setMap] = useState<any>(null);
  const [isMapFullyLoaded, setIsMapFullyLoaded] = useState(false);

  useEffect(() => {
    if (map || !mapContainer.current) return;

    const initializeMap = new mapboxgl.Map({
      container: mapContainer.current,
      style: process.env.REACT_APP_MAPBOX_STYLE_URL ?? "",
      center: [-156.44636531857395, 62.40265300551266],
      zoom: 2,
      minZoom: 0.999,
      renderWorldCopies: false,
      
      // @ts-ignore
      projection: {
        name: "mercator",
      },
    });

    const nav = new mapboxgl.NavigationControl({
      visualizePitch: true,
    });
    initializeMap.addControl(nav, "bottom-right");

    initializeMap.addControl(new mapboxgl.FullscreenControl());

    initializeMap.on("load", () => setIsMapFullyLoaded(true));

    initializeMap.getCanvas().style.cursor = 'zoom-in';

    setMap(initializeMap);

    return () => {
      setIsMapFullyLoaded(false);
    };
  }, []);

  return { map, isMapFullyLoaded };
};
